module.exports = __webpack_public_path__ + "static/media/TS-asset1.d4a7a6da.svg";